module.exports = __webpack_public_path__ + "static/media/Flight_Briefing_portfolio_image.3e981fa2.jpg";